var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-statistics__tab"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow('visits-table')),expression:"isShow('visits-table')"}],class:[
      'section-statistics__row',
      {'section-statistics__row--long-table-mode': _vm.longTablePart && _vm.longTablePart === 'visits-table'}
    ]},[_c('BarPart',{attrs:{"isLoading":_vm.isLoading,"isError":_vm.isError,"value":_vm.value}}),_c('TablePart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }